import { StickyNote } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const fmt = (ts) => (ts ? new Date(ts).toLocaleString([], { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "");

// Small amber note icon; tap/hover shows the clock-out note(s).
export const ClockOutNoteIcon = ({ notes, testid }) => {
  const list = (Array.isArray(notes) ? notes : [notes]).filter((n) => n && (n.note || typeof n === "string"));
  if (!list.length) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className="inline-flex items-center ml-1 text-amber-500 hover:text-amber-600 align-middle" title={list.map((n) => n.note || n).join("\n")} data-testid={testid}>
          <StickyNote className="h-3.5 w-3.5" />{list.length > 1 && <span className="text-[10px] font-bold ml-0.5">{list.length}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-3 space-y-2 text-sm">
        <p className="text-[11px] font-semibold uppercase tracking-wide text-amber-700">Clock-out note{list.length > 1 ? "s" : ""}</p>
        {list.map((n, i) => (
          <div key={i} className="border-l-2 border-amber-300 pl-2">
            <p className="text-slate-800 whitespace-pre-wrap">{n.note || n}</p>
            {n.at && <p className="text-[11px] text-slate-400">{fmt(n.at)}</p>}
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
};
